// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"792f684f","135":"80aa2072"}[chunkId] + ".chunk.css";
};